/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-14 22:42:13
 * @LastEditors: liuziwei
 * @Description: 划线价组件
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view wx:if="{{price}}" class="crossed-price-container" wx:style="{{ {color: '#CCCCCC'}}}">
    <text wx:if="{{prefix}}">{{ prefix }}</text>
    <text class="price">￥{{ price }}</text>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      prefix: {
        type: String,
        value: () => ''
      },
      price: {
        type: Number,
        value: () => 0
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .price
    text-decoration line-through
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
